const updateHistory = async (method, url, state) => {
  try {
    await window.history[method](state, "", url)
  } catch (e) {
    // When updating the history fails, we set an empty object at the key
    // ReactRB. This allows a consumer to see the failure and handle it
    // appropriately.
    await window.history[method]({ ReactRB: {} }, url)
  }
}

const history = {
  push: async (url, state) => {
    await updateHistory("pushState", url, state)
  },
  replace: async (url, state) => {
    await updateHistory("replaceState", url, state)
  }
}

export default history
